<!-- 会议详情 -->
<template>
    <div class='container'>
        <div class="main">
            <div class="mainBox" v-for="items in 2" :key="items">
                <div class="divLine">
                    <svg-icon style="margin-right: 0.05rem;height: 0.2rem;" iconClass="naozhong"></svg-icon>
                    <div>
                        <p class="p_1">时间1:2021-06-20 1晚</p>
                        <p class="p_2">想大约下午5点开始用会场晚上10点结束 <span>(有内容显示 没内容该行不显示)</span> </p>
                    </div>
                </div>
                <div class="divLine">
                    <svg-icon style="margin-right: 0.05rem;height: 0.2rem;" iconClass="person"></svg-icon>
                    <p class="p_1">人数:相对准确30人 (另一种情况是: 大致人数:30-50)</p>
                </div>
                <div>
                    <div class="divLine" style="margin-bottom: 0.2rem;">
                        <el-checkbox v-model="checked"></el-checkbox>
                        <p class="p_1">类型:年会</p>
                    </div>
                    <div class="detail" v-for="item in 2" :key="item">
                        <p class="p_3">需要:福临门会议室期望3000￥以内</p>
                        <p class="p_2">预算可以提高，人数不会超过35 <span>(有内容显示 没内容该行不显示)</span> </p>
                        <p class="p_3">想比较 龙腾会议室 的价格</p>
                    </div>
                </div>
            </div>
            <div class="divLine">
                <svg-icon style="margin-right: 0.05rem;height: 0.2rem;" iconClass="md-spa"></svg-icon>
                <p class="p_1">需要的设备及服务:</p>
            </div>
            <div class="serviceBox">
                <div class="serviceLine" v-for="(item, keys) in siteService" :key="keys">
                    <p class="serviceTitle">{{ keys }}</p>
                    <p class="serviceSelect" v-for="(n, index) in item" :key="index">{{ n }}</p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {},
    data() {
        return {
            checked: [],
            siteService: {
                '设备': ['投影仪', 'LED', '话筒'],
                '物料': ['会议桌牌', '房间欢迎卡'],
                '餐饮': ['茶歇', '矿泉水']
            }
        }
    },
    computed: {},
    watch: {},
    methods: {

    },
    created() {

    },
    mounted() {

    },
}
</script>
<style lang='scss' scoped>
/deep/ .el-checkbox__inner {
    border-radius: 50%;
    height: 0.18rem !important;
    width: 0.18rem !important;
    margin: 0 0.06rem;
}

.container {
    .p_1 {
        color: #DB4E1A;
        font-weight: bold;
    }

    .p_2 {
        color: #000;

        span {
            color: #919191;
        }
    }

    .p_3 {
        color: #000;
        font-weight: bold;
    }

    .main {
        .mainBox {
            margin-bottom: 0.2rem;
        }

        &:nth-last-child(1) {
            margin-bottom: 0;
        }

        .divLine {
            font-size: 0.15rem;

            margin-bottom: 0.1rem;
            display: flex;


        }

        .detail {
            margin-left: 0.3rem;
            margin-bottom: 0.2rem;
            line-height: 0.25rem;

            &:nth-last-child(1) {
                margin-bottom: 0;
            }
        }

        .serviceBox {
            margin-left: 0.3rem;

            .serviceLine {
                display: flex;
                align-items: center;
                margin-bottom: 0.15rem;

                &:nth-last-child(1) {
                    margin-bottom: 0;
                }

                .serviceTitle {
                    color: rgba(219, 78, 26, 0.79);
                    font-size: 0.14rem;
                    font-family: SourceHanSansSC-regular;
                    margin-right: 0.2rem;
                }

                .serviceSelect {
                    margin-right: 0.1rem;
                    border-radius: 4px;
                    background-color: rgba(237, 241, 242, 1);
                    color: rgba(16, 16, 16, 1);
                    font-size: 0.12rem;
                    font-family: PingFang SC;
                    padding: 0.05rem 0.1rem;

                    &:nth-last-child(1) {
                        margin-right: 0;
                    }
                }

            }
        }
    }

}
</style>